/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setWithExpiry, isLoggedIn, getUser } from '../AuthService';
import * as default_data from '../config.js'

function BotRoute({ children }) {
    const [authUser, setAuthUser] = useState(isLoggedIn());
    const [loading, setLoading] = useState(!authUser);
    const [redirectToLogin, setRedirectToLogin] = useState(false);
    var loaded_static = false;

    useEffect(() => {
        if(loaded_static) {
            return;
          }
        
        loaded_static = true;
  
        if (!authUser) {            
            fetch(default_data.default_user_service_url_no_cac + '/login-bot', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                })
              })
                .then(response => {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error('An error occurred while logging in.');
                })
                .then(data => {
                  if(data.status != 200) {
                      throw new Error(data.response);
                  }
                  data = data.response;
          
                  // Save the access token and user data to local storage and redirect to the dashboard
                  setWithExpiry('access_token', data.access_token);
                  setWithExpiry('user', JSON.stringify(data.user));                  
                  setAuthUser(true);
                  setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                });
        }
        else {
            var user = getUser();
            if(user.type !== 'bot') {
                setRedirectToLogin(true);
            }
            setLoading(false);
        }
    }, []);

    if (redirectToLogin) {
        return <Navigate to="/login" />;
    }

    if (loading) {
        return <div>Loading...</div>; // or return a loading spinner
    }

    // authorized so return child components
    return children;
}

export { BotRoute };
